import { render, staticRenderFns } from "./TabPhotoChromic.vue?vue&type=template&id=604c15e0&"
import script from "./TabPhotoChromic.vue?vue&type=script&lang=ts&"
export * from "./TabPhotoChromic.vue?vue&type=script&lang=ts&"
import style0 from "./TabPhotoChromic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports